// Route guard: no session → /auth/login (remembering where they were going).
// A LOCKED session is still a session — the shell renders under the lock.

import { useSyncExternalStore, type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { sessionStore } from '@/lib/auth';

export function useAuthenticated(): boolean {
  return useSyncExternalStore(sessionStore.subscribe, sessionStore.isAuthenticated, sessionStore.isAuthenticated);
}

export function RequireAuth({ children }: { children: ReactNode }) {
  const authed = useAuthenticated();
  const location = useLocation();
  if (!authed) return <Navigate to="/auth/login" state={{ from: location.pathname + location.search }} replace />;
  return <>{children}</>;
}
